import Page, { PageProps } from '@/components/page/Page';

export type PublicPageProps = PageProps;

const PublicPage = (props: PublicPageProps): JSX.Element => <Page {...props} />;

export default PublicPage;
